export default async ()=> {
    const res = await fetch('/sectionData/hotel.json')
    const data = await res.json()
    return data
}